import clsx from 'clsx';

import { FORM_KEY } from 'constants/';

const getButtonClasses = (formKey: string) =>
  clsx(
    'apple-pay-button-container',
    formKey === FORM_KEY.DEFAULT && 'base-gpay',
    formKey === FORM_KEY.SZ && 'sz-gpay',
    formKey === FORM_KEY.XBET && 'xbet-gpay',
    formKey === FORM_KEY.FONBET && 'fonbet-gpay',
  );

const StatusMessage = ({ formKey, message }: { formKey: string; message: string }) => (
  <div
    className={clsx(
      getButtonClasses(formKey),
      'font-sans text-sm font-normal leading-5 text-center text-black opacity-40 w-full border border-black border-opacity-20 rounded-[8px] md:w-[160px] py-2 px-4',
    )}
  >
    {message}
  </div>
);

export { StatusMessage, getButtonClasses };
